import cx from 'classnames';
import { FiArrowUp, FiArrowDown, FiUsers } from "react-icons/fi";
import type { Entry } from '@/lib/types';
import styles from './SongDisplay.module.css';

export const SongDisplay = ({
  entry,
  showVotes,
}: {
  entry: Entry,
  showVotes?: boolean,
}) => {
  return (
    <div className={styles.songDisplay}>
      <div className={styles.imageContainer}>
        <img alt="Album art" src={entry.albumImage} width={showVotes ? 64 : 48} height={showVotes ? 64 : 48} />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.songName}>{entry.name}</div>
        <div className={styles.songArtist}>{entry.artist}</div>
        {showVotes && (
          <div className={styles.songVotes}>
            <div className={cx(
              styles.songVotesItem,
              styles.songVotesItemVoteTotal
            )}>
              {entry.voteTotal}
            </div>
            <div className={styles.songVotesSeparator}>
              |
            </div>
            <div
              className={cx(
                styles.songVotesItem,
                styles.songVotesItemVoters
              )}
            >
              <span className={styles.songVotesItemIcon}>
                <FiUsers />
              </span>
              {entry.votes.length}
            </div>
            <div className={cx(
              styles.songVotesItem,
              styles.songVotesItemUpvotes
            )}>
              <span className={styles.songVotesItemIcon}>
                <FiArrowUp />
              </span>
              {entry.votes.reduce((acc, vote) => acc + (vote.count > 0 ? vote.count : 0), 0)}
            </div>
            <div className={cx(
              styles.songVotesItem,
              styles.songVotesItemDownvotes
            )}>
              <span className={styles.songVotesItemIcon}>
                <FiArrowDown />
              </span>
              {entry.votes.reduce((acc, vote) => acc - (vote.count < 0 ? vote.count : 0), 0)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
